import { Button, Divider, FormControl, IconButton, Modal, Stack, TextField, Typography } from '@mui/material';
import { useContext, useEffect, useState } from 'react';

import ProgressModal from '../../../../components/Progress/ProgressModal/ProgressModal';
import { AppContext } from '../../../../core/context/appContextProvider';
import { postNewTransType } from '../../../../services/fund.service';
import { NewTransType, TransTypeBucket } from '../../../../utils/types/fund.type';
import { StyledBox, TransactionNameTextfield, ValueFormControl } from './NewTransactionModal.styles';

type Props = {
  clientId: string;
  open: boolean;
  transTypeModel: TransTypeBucket[];
  onSuccess: () => void;
  onClose: () => void;
};

const NewTransactionModal: React.FC<Props> = (props: Props) => {
  const { informationAlert } = useContext(AppContext);
  const { clientId, open, transTypeModel, onSuccess, onClose } = props;
  const [name, setName] = useState<string>('');
  const [newTransTypeModel, setNewTransTypeModel] = useState<TransTypeBucket[]>([]);
  const [isSendingData, setSendingData] = useState<boolean>(false);

  useEffect(() => {
    setNewTransTypeModel(transTypeModel);

  }, [transTypeModel]);

  const handleNewTransactionSave = async () => {

    if (newTransTypeModel && name) {
      const newTransType: NewTransType = {
        typeName: name,
        transactionBuckets: newTransTypeModel,
        tenantId: clientId
      };

      try {
        setSendingData(true);
        await postNewTransType(newTransType);

        setSendingData(false);
        onSuccess();
        onClose();
      } catch (e) {
        informationAlert(GENERIC_ERROR_MESSAGE, "error");
      }
    }
  };

  const handleNewTransactionValues = (action: number, name: string) => {
    const newValues = [...newTransTypeModel];
    const updatedValue = newValues.find(v => v.label === name);

    if (updatedValue) {
      updatedValue.value = updatedValue.value + action;
    }

    setNewTransTypeModel(newValues);
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      id="mdl_new_transaction"
      aria-labelledby="modal_newtranstype_title"
      aria-describedby="modal_newtranstype_description"
    >
      <StyledBox>

        <ProgressModal
          id="modal_saving_mapping"
          showProgress={isSendingData}
          text="Saving new transaction type..."
        />

        <Typography id="modal_newtranstype_title" component="h2">
          Create Custom Ark Transaction Type
        </Typography>
        <Typography id="modal_newtranstype_description" variant='body2'>
          This will create a new Ark Transaction Type that you can then map accounts to. This custom type will also appear in the relevant reports and in your Workbook.
        </Typography>
        <Divider />
        <FormControl>
          <TransactionNameTextfield
            id="txt_new_transtype_name"
            label="Transaction Name"
            variant="outlined"
            onChange={e => setName(e.target.value)}
            size="small"
          />

          {newTransTypeModel.map(bucket =>
            <ValueFormControl key={bucket.label}>
              <Typography variant="body2">{bucket.label}</Typography>
              <IconButton
                id={`btn_decrease_${bucket.label.toLowerCase()}`}
                aria-label={`lbl_decrease_${bucket.label.toLowerCase()}`}
                onClick={() => handleNewTransactionValues(-1, bucket.label)}
                disabled={bucket.value === -1}
              > -
              </IconButton>
              <TextField
                required
                id={`txt_newtrans_${bucket.label.toLowerCase()}`}
                variant="outlined" value={bucket.value}
                size="small"
              />
              <IconButton
                id={`btn_increase_${bucket.label.toLowerCase()}`}
                aria-label={`lbl_increase_${bucket.label.toLowerCase()}`}
                onClick={() => handleNewTransactionValues(1, bucket.label)}
                disabled={bucket.value === 1}
              >
                +
              </IconButton>
            </ValueFormControl>
          )}
          <Stack direction="row" spacing={4} sx={{ mt: 3 }}>
            <Button
              id="btn_save_new_transtype"
              variant="contained"
              onClick={handleNewTransactionSave}
              disabled={!name}
            >
              Save Custom Type
            </Button>

            <Button id="btn_cancel_save" variant="outlined" onClick={onClose}>Cancel</Button>
          </Stack>
        </FormControl>

      </StyledBox>
    </Modal>
  );
};

export default NewTransactionModal;

function GENERIC_ERROR_MESSAGE(GENERIC_ERROR_MESSAGE: any, arg1: string) {
  throw new Error('Function not implemented.');
}
